import bookingsPage from "./bookings/bookings.module";
import loginPage from "./login/login.module";
import customersPage from "./customers/customers.module";
import bookingPage from "./booking/booking.module";
import customerPage from "./customer/customer.module";
import corporatesPage from "./corporates/corporates.module";
import corporatePage from "./corporate/corporate.module";
import fleetPage from "./fleet/fleet.module";
import busesPage from "./buses/buses.module";
import captainsPage from "./captains/captains.module";
import companiesPage from "./companies/companies.module";
import companyPage from "./company/company.module";
import captainPage from "./captain/captain.module";
import routesPage from "./routes/routes.module";
import stationsPage from "./stations/stations.module";
import ridesPage from "./rides/rides.module";
import stationPage from "./station/station.module";
import routePage from "./route/route.module";
import settingsPage from "./settings/settings.module";
import bustypesPage from "./bustypes/bustypes.module";
import promotionPage from "./promotion/promotion.module";
import topupsPage from "./topups/topups.module";
import tickettypesPage from "./tickettypes/tickettypes.module";
import districtsPage from "./districts/districts.module";
import citiesPage from "./cities/cities.module";
import ridePage from "./ride/ride.module";
import busPage from "./bus/bus.module";
import promotionsPage from "./promotions/promotions.module";
import cityPage from "./city/city.module";
import districtPage from "./district/district.module";
import bustypePage from "./bustype/bustype.module";
import bulkcreditsPage from "./bulkcredits/bulkcredits.module";
import dispatchersPage from "./dispatchers/dispatchers.module";
import dispatcherPage from "./dispatcher/dispatcher.module";
import universalPage from "./universal/universal.module";
import ticketsPage from "./tickets/tickets.module";
import ticketPage from "./ticket/ticket.module";
import reportsPage from "./reports/reports.module";
import reportPage from "./report/report.module";
import ratingsPage from "./ratings/ratings.module";
import statsPage from "./stats/stats.module";
import basicPlanPage from "./basicPlan/basicPlan.module";
import backupPlanPage from "./backupPlan/backupPlan.module";
import deductionPlanPage from "./deductionPlan/deductionPlan.module";
import basicplansPage from "./basicplans/basicplans.module";
import backupplansPage from "./backupplans/backupplans.module";
import deductionplansPage from "./deductionplans/deductionplans.module";
import plansPage from "./plans/plans.module";
import invoicesPage from "./invoices/invoices.module";
import captainFinancePage from "./captainFinance/captainFinance.module";
import captainInvoicesPage from "./captainInvoices/captainInvoices.module";
import captainInvoicePage from "./captainInvoice/captainInvoice.module";
import invoicePage from "./invoice/invoice.module";
import invoiceItemPage from "./invoiceItem/invoiceItem.module";
import invoiceItemsPage from "./invoiceItems/invoiceItems.module";
import creditsPage from "./credits/credits.module";
import homePage from "./home/home.module";
import holidaysPage from "./holidays/holidays.module";
import holidayPage from "./holiday/holiday.module";
import backupsPage from "./backups/backups.module";
import backupPage from "./backup/backup.module";
import backupSchedulePage from "./backupSchedule/backupSchedule.module";
import backupSchedulesPage from "./backupSchedules/backupSchedules.module";
import reservationPage from "./reservation/reservation.module";
import stationsHeatmapPage from "./stationsHeatmap/stationsHeatmap.module";
import reportGeneratorPage from "./reportGenerator/reportGenerator.module";
import routePlanningPage from "./routePlanning/routePlanning.module";
import routeEditPage from "./routeEdit/routeEdit.module";
import userVerificationsPage from "./userVerifications/userVerifications.module";
import loansPage from "./loans/loans.module";
import loanPage from "./loan/loan.module";
import tagsPage from "./tags/tags.module";
import tagPage from "./tag/tag.module";
import redirectorPage from "./redirector/redirector.module";
import eventsPage from "./events/events.module";
import eventPage from "./event/event.module";
import travelRequestsPage from "./travelRequests/travelRequests.module";
import travelRequestPage from "./travelRequest/travelRequest.module";
import privateBusRequestsPage from "./privateBusRequests/privateBusRequests.module";
import privateBusRequestPage from "./privateBusRequest/privateBusRequest.module";
import pricingsPage from "./pricings/pricings.module";
import pricingPage from "./pricing/pricing.module";
import bulkBonusesPage from "./bulkBonuses/bulkBonuses.module";
import corporateInvoiceItemPage from "./corporateInvoiceItem/corporateInvoiceItem.module";
import corporateInvoicePage from "./corporateInvoice/corporateInvoice.module";
import contractorsPage from "./contractors/contractors.module";
import contractorPage from "./contractor/contractor.module";
import packagesPage from "./packages/packages.module";
import commuterPackagePage from "./commuterPackage/commuterPackage.module";
import contractorInvoicePage from "./contractorInvoice/contractorInvoice.module";
import contractorInvoiceItemPage from "./contractorInvoiceItem/contractorInvoiceItem.module";
import authorizationPage from "./authorization/authorization.module";
import bulkBonusDetailsPage from "./bulkBonusDetails/bulkBonusDetails.module";
import fileDownloadPage from "./fileDownload/fileDownload.module";
import corporateHolidayPage from "./corporateHoliday/corporateHoliday.module";
import bulkScriptsPage from "./bulkScripts/bulkScripts.module";
import bulkScriptsUploadPage from "./bulkScriptsUpload/bulkScriptsUpload.module";
import variablePlansPage from "./variablePlans/variablePlans.module";
import variablePlanPage from "./variablePlan/variablePlan.module";
import corporateTransportationSubmissionsPage from "./corporateTransportationSubmissions/corporateTransportationSubmissions.module";
import corporateTransportationSubmissionPage from "./corporateTransportationSubmission/corporateTransportationSubmission.module";
import lostPage from "./lost/lost.module";
import countriesPage from "./countries/countries.module";
import countryPage from "./country/country.module";
import fulfillmentPlansPage from "./fulfillmentPlans/fulfillmentPlans.module";
import fulfillmentPlanPage from "./fulfillmentPlan/fulfillmentPlan.module";
import manualInvoiceItemsPage from "./manualInvoiceItems/manualInvoiceItems.module";
import manualInvoiceItemPage from "./manualInvoiceItem/manualInvoiceItem.module";
import captainAppVersionsPage from "./captainAppVersions/captainAppVersions.module";
import captainAppVersionPage from "./captainAppVersion/captainAppVersion.module";
import paymentMethodsPage from "./paymentMethods/paymentMethods.module";
import paymentMethodPage from "./paymentMethod/paymentMethod.module";
import bulkInvoiceItemTypesUploadPage from "./bulkInvoiceItemTypesUpload/bulkInvoiceItemTypesUpload.module";
import bulkInvoiceItemTypesUploadsPage from "./bulkInvoiceItemTypesUploads/bulkInvoiceItemTypesUploads.module";
import bulkInvoiceItemTypesUploadDetailsPage from "./bulkInvoiceItemTypesUploadDetails/bulkInvoiceItemTypesUploadDetails.module";
import finesReimbursementsPage from "./finesReimbursements/finesReimbursements.module";
import fineReimbursementPage from "./fineReimbursement/fineReimbursement.module";
import corporateContractApprovalsPage from "./corporateContractApprovals/corporateContractApprovals.module";
import captainVerificationPage from "./captainVerification/captainVerification.module";
import pendingBookingModule from "./pendingBooking/pendingBooking.module";

const pagesModule = angular.module("app.pages", [
  bookingsPage.name,
  loginPage.name,
  customersPage.name,
  bookingPage.name,
  customerPage.name,
  corporatesPage.name,
  corporatePage.name,
  fleetPage.name,
  busesPage.name,
  captainsPage.name,
  companiesPage.name,
  companyPage.name,
  captainPage.name,
  routesPage.name,
  stationsPage.name,
  ridesPage.name,
  stationPage.name,
  routePage.name,
  settingsPage.name,
  bustypesPage.name,
  promotionPage.name,
  topupsPage.name,
  tickettypesPage.name,
  districtsPage.name,
  citiesPage.name,
  ridePage.name,
  busPage.name,
  promotionsPage.name,
  cityPage.name,
  districtPage.name,
  bustypePage.name,
  bulkcreditsPage.name,
  dispatchersPage.name,
  dispatcherPage.name,
  universalPage.name,
  ticketsPage.name,
  ticketPage.name,
  reportsPage.name,
  reportPage.name,
  ratingsPage.name,
  statsPage.name,
  basicPlanPage.name,
  backupPlanPage.name,
  deductionPlanPage.name,
  basicplansPage.name,
  backupplansPage.name,
  deductionplansPage.name,
  plansPage.name,
  invoicesPage.name,
  captainFinancePage.name,
  captainInvoicesPage.name,
  captainInvoicePage.name,
  invoicePage.name,
  invoiceItemPage.name,
  invoiceItemsPage.name,
  creditsPage.name,
  creditsPage.name,
  homePage.name,
  holidaysPage.name,
  holidayPage.name,
  backupsPage.name,
  backupPage.name,
  backupSchedulePage.name,
  backupSchedulesPage.name,
  reservationPage.name,
  stationsHeatmapPage.name,
  reportGeneratorPage.name,
  routePlanningPage.name,
  routeEditPage.name,
  userVerificationsPage.name,
  loansPage.name,
  loanPage.name,
  tagsPage.name,
  tagPage.name,
  redirectorPage.name,
  eventsPage.name,
  eventPage.name,
  travelRequestsPage.name,
  travelRequestPage.name,
  privateBusRequestsPage.name,
  privateBusRequestPage.name,
  pricingsPage.name,
  pricingPage.name,
  bulkBonusesPage.name,
  corporateInvoiceItemPage.name,
  corporateInvoicePage.name,
  contractorsPage.name,
  contractorPage.name,
  packagesPage.name,
  commuterPackagePage.name,
  contractorInvoicePage.name,
  contractorInvoiceItemPage.name,
  fileDownloadPage.name,
  variablePlansPage.name,
  variablePlanPage.name,
  bulkBonusDetailsPage.name,
  fileDownloadPage.name,
  corporateHolidayPage.name,
  bulkScriptsPage.name,
  bulkScriptsUploadPage.name,
  authorizationPage.name,
  corporateTransportationSubmissionsPage.name,
  corporateTransportationSubmissionPage.name,
  lostPage.name,
  countriesPage.name,
  countryPage.name,
  fulfillmentPlansPage.name,
  fulfillmentPlanPage.name,
  manualInvoiceItemsPage.name,
  manualInvoiceItemPage.name,
  captainAppVersionsPage.name,
  captainAppVersionPage.name,
  paymentMethodsPage.name,
  paymentMethodPage.name,
  bulkInvoiceItemTypesUploadPage.name,
  bulkInvoiceItemTypesUploadsPage.name,
  bulkInvoiceItemTypesUploadDetailsPage.name,
  finesReimbursementsPage.name,
  fineReimbursementPage.name,
  corporateContractApprovalsPage.name,
  captainVerificationPage.name,
  pendingBookingModule.name,
]);

export default pagesModule;



// WEBPACK FOOTER //
// ./src/pages/index.js